export const HEADERS = {}
export const baseUrl = import.meta.env.VITE_BASEURL
export const xApiKey = import.meta.env.VITE_X_API_KEY
export const xApiIv = import.meta.env.VITE_X_API_IV

export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
}

type OperationType = {
  EndPoint: string | any
  Method: any
}

type ModuleType = {
  [operation: string]: OperationType
}

type ApiRoutesType = {
  [module: string]: ModuleType
}

const ApiRoutes: any = {
  //! put type here
  Auth: {
    Create: {
      EndPoint: "/auth/create",
      Method: HttpMethod.Post,
    },
    Login: {
      EndPoint: "/auth/login",
      Method: HttpMethod.Post,
    },
    CreatePassword: {
      EndPoint: "/auth/password_challenge",
      Method: HttpMethod.Post,
    },
    VerifyEmail: {
      EndPoint: "/auth/verify_email",
      Method: HttpMethod.Post,
    },
    ChangePassword: {
      EndPoint: "/auth/change_password",
      Method: HttpMethod.Post,
    },
    ForgotPassword: {
      EndPoint: "/auth/forgot_password",
      Method: HttpMethod.Post,
    },
    ResetPassword: {
      EndPoint: "/auth/reset_password",
      Method: HttpMethod.Post,
    },
    AdminLogin: {
      EndPoint: "/auth/login",
      Method: HttpMethod.Post,
    },
    AssignPerm: {
      EndPoint: "/permissions/assign_permission",
      Method: HttpMethod.Post,
    },
    RemovePerm: {
      EndPoint: "/permissions/remove_permission",
      Method: HttpMethod.Delete,
    },
    UserRole: {
      EndPoint: (email: string) => `/users/status?email=${email}`,
      Method: HttpMethod.Get,
    },
  },
  Admin: {
    AdminInfo: {
      EndPoint: "/users/current_user",
      Method: HttpMethod.Get,
    },
    AllAdvisors: {
      EndPoint: (groupSk: string) =>
        `groups/users?group_sk=${groupSk}&role_category=advisor`,
      Method: HttpMethod.Get,
    },
    AllCsm: {
      EndPoint: (groupSk: string) =>
        `groups/users?group_sk=${groupSk}&role_category=csm`,
      Method: HttpMethod.Get,
    },
    AllGa: {
      EndPoint: (groupSk: string) =>
        `groups/users?group_sk=${groupSk}&role_category=group_admin`,
      Method: HttpMethod.Get,
    },
    AllOfficeManagers: {
      EndPoint: (groupSk: string) =>
        `groups/users?group_sk=${groupSk}&role_category=office_manager`,
      Method: HttpMethod.Get,
    },
  },
  Dashboard: {
    Overview: {
      EndPoint: (group_sk: string, region: string, practice_sk: string) =>
        `/huddle/huddle_summary?group_sk=${group_sk}&practice_sk=${practice_sk}&region=${region}&is_dashboard=true`,
      Method: HttpMethod.Get,
    },
    Opportunity: {
      EndPoint: (group_sk: string, region: string, practice_sk: string) =>
        `/opportunity/active?group_sk=${group_sk}&practice_sk=${practice_sk}&region=${region}&is_dashboard=true`,
      Method: HttpMethod.Get,
    },
    Doctors: {
      EndPoint: (
        group_sk: string,
        region: string,
        practice_sk: string,
        start_date: string,
        end_date: string,
      ) =>
        `dashboard/doctors?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}&start_date=${start_date}&end_date=${end_date}`,
      Method: HttpMethod.Get,
    },
    Hygienists: {
      EndPoint: (
        group_sk: string,
        region: string,
        practice_sk: string,
        start_date: string,
        end_date: string,
      ) =>
        `dashboard/hygienists?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}&start_date=${start_date}&end_date=${end_date}`,
      Method: HttpMethod.Get,
    },
    DashboardCharts: {
      EndPoint: (group_sk: string, region: string, practice_sk: string) =>
        `dashboard/charts?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    TopMetrics: {
      EndPoint: "/dashboard/top_metrics",
      Method: HttpMethod.Get,
    },
    TopMetricCharts: {
      EndPoint: "dashboard/dynamic_charts",
      Method: HttpMethod.Post,
    },
    AdminDashboard: {
      EndPoint: "/dashboard/admin",
      Method: HttpMethod.Get,
    },
    CsmDashboard: {
      EndPoint: (csmId: any) => `/dashboard/csm?csm_id=${csmId}`,
      Method: HttpMethod.Get,
    },
    AdvisorDashboard: {
      EndPoint: (advisorId: any) =>
        `/dashboard/advisor?advisor_id=${advisorId}`,
      Method: HttpMethod.Get,
    },
    GaDashboard: {
      EndPoint: (gaId: any) => `/dashboard/group_admin?group_admin_id=${gaId}`,
      Method: HttpMethod.Get,
    },
  },
  Agenda: {
    AgendaList: {
      EndPoint: (creatorId: any, tab: any) =>
        `/meetings?creator_id=${creatorId}&tab=${tab}`,
      Method: HttpMethod.Get,
    },
    AgendaActionItems: {
      EndPoint: (meetingId: any) =>
        `/meetings/action_items?meeting_id=${meetingId}`,
      Method: HttpMethod.Get,
    },
    NewAgenda: {
      EndPoint: `/meetings/create`,
      Method: HttpMethod.Post,
    },
    UpdateAgenda: {
      EndPoint: (meetingId: any) =>
        `/meetings/update_meeting?meeting_id=${meetingId}`,
      Method: HttpMethod.Patch,
    },
    AddActionItems: {
      EndPoint: `/meetings/add_action_items`,
      Method: HttpMethod.Post,
    },
    UpdateActionItem: {
      EndPoint: (itemId: any) => `/meetings/update_actionitem?id=${itemId}`,
      Method: HttpMethod.Patch,
    },
    DelAgenda: {
      EndPoint: (meetingId: any) => `/meetings?meeting_id=${meetingId}`,
      Method: HttpMethod.Delete,
    },
    DelActionItem: {
      EndPoint: (meetingId: any, itemId: any) =>
        `/meetings/action_item?meeting_id=${meetingId}&action_item_id=${itemId}`,
      Method: HttpMethod.Delete,
    },
  },
  Providers: {
    Specialities: {
      EndPoint: "/groups/hierarchy/speciality",
      Method: HttpMethod.Get,
    },
    Providers: {
      EndPoint: "/groups/hierarchy/providers",
      Method: HttpMethod.Post,
    },
    ProviderMetrics: {
      EndPoint: (metricBucketId: any) =>
        `/blueprint/metricsForBucket?metric_bucket_id=${metricBucketId}`,
      Method: HttpMethod.Get,
    },
    ProviderData: {
      EndPoint: "/provider",
      Method: HttpMethod.Post,
    },
  },
  Metric: {
    MetricTabs: {
      EndPoint: "/blueprint",
      Method: HttpMethod.Get,
    },
    MetricGroups: {
      EndPoint: "/groups",
      Method: HttpMethod.Get,
    },
    MetricGroupsBoarded: {
      EndPoint: "/groups/assigned",
      Method: HttpMethod.Get,
    },
    MetricRegionsByGroups: {
      EndPoint: "/groups/hierarchy/regions",
      Method: HttpMethod.Post,
    },
    MetricPracticesByRegions: {
      EndPoint: "/groups/hierarchy/practices",
      Method: HttpMethod.Post,
    },
    MetricPracticesByGroups: {
      EndPoint: "/groups/hierarchy/practices",
      Method: HttpMethod.Post,
    },
    AssignedBucketsToGroup: {
      EndPoint: (groupSk: any) =>
        `/groups/template/assignedbuckets?group_sk=${groupSk}`,
      Method: HttpMethod.Get,
    },
    Blueprint: {
      NewBlueprintBucket: {
        EndPoint: "/blueprint/bucket/create",
        Method: HttpMethod.Post,
      },
      NewBlueprintMetric: {
        EndPoint: "/blueprint/metric/create",
        Method: HttpMethod.Post,
      },
      MetricValueType: {
        EndPoint: "/blueprint/column",
        Method: HttpMethod.Patch,
      },
      GoalType: {
        EndPoint: "/blueprint/goal_type",
        Method: HttpMethod.Patch,
      },
      MetricBenchmark: {
        EndPoint: "/blueprint/metric_benchmark",
        Method: HttpMethod.Patch,
      },
      BucketName: {
        EndPoint: "/blueprint/bucket/change_name",
        Method: HttpMethod.Patch,
      },
      DeleteBucket: {
        EndPoint: (metricBucketId: any) =>
          `/blueprint/bucket/delete?metric_bucket_id=${metricBucketId}`,
        Method: HttpMethod.Delete,
      },
      MetricName: {
        EndPoint: "/blueprint/metric/change_name",
        Method: HttpMethod.Patch,
      },
      DeleteMetric: {
        EndPoint: (metricId: any) =>
          `/blueprint/metric/delete?metric_id=${metricId}`,
        Method: HttpMethod.Delete,
      },
      AssignMetrics: {
        EndPoint: "groups/template/assign",
        Method: HttpMethod.Post,
      },
      DndBucket: {
        EndPoint: "/blueprint/bucket/change_sequence",
        Method: HttpMethod.Patch,
      },
      DndMetric: {
        EndPoint: "/blueprint/metric/change_sequence",
        Method: HttpMethod.Patch,
      },
    },
    Goals: {
      GoalsData: {
        EndPoint: (groupSk: any, year: any) =>
          `/groups/goals/template?group_sk=${groupSk}&year=${year}`,
        Method: HttpMethod.Get,
      },
      GoalsRegions: {
        EndPoint: (groupSk: any) =>
          `/groups/hierarchy/regions?group_sk=${groupSk}`,
        Method: HttpMethod.Get,
      },
      GoalsPractices: {
        EndPoint: (groupSk: any, region: any) =>
          `/groups/hierarchy/practices?group_sk=${groupSk}&region=${region}`,
        Method: HttpMethod.Get,
      },
      GoalsAvailableYears: {
        EndPoint: (groupSk: any) =>
          `/groups/goals/available_years?group_sk=${groupSk}`,
        Method: HttpMethod.Get,
      },
      MetricGoalsByBucket: {
        EndPoint: (groupSk: any, metricBucketId: any, year: any) =>
          `/groups/goals/bybucket?group_sk=${groupSk}&metric_bucket_id=${metricBucketId}&year=${year}`,
        Method: HttpMethod.Get,
      },
      YearMetricGoals: {
        EndPoint: `/groups/goals/set_to_year`,
        Method: HttpMethod.Post,
      },
      MonthMetricGoals: {
        EndPoint: `/groups/goals/set_to_month`,
        Method: HttpMethod.Post,
      },
      SetMetricGoals: {
        EndPoint: `/groups/goals/publish`,
        Method: HttpMethod.Post,
      },
    },
    Oppprtunity: {
      OpportunityDashboard: {
        EndPoint: (
          advisor_id: any,
          groupSK: any,
          region: any,
          practice: any,
          status: any,
          page?: number,
          limit?: number,
        ) => {
          let url = `/opportunity/fetch?advisor_id=${advisor_id}&group_sk=${groupSK}&region=${region}&practice_sk=${practice}&opportunity_status=${status}`
          if (page !== undefined && limit !== undefined) {
            url += `&page=${page}&limit=${limit}`
          }
          return url
        },
        Method: HttpMethod.Get,
      },
      OpportunityDashboardByRole: {
        EndPoint: (groupSK: any, region: any, practice: any, status: any) =>
          `/opportunity/fetch?group_sk=${groupSK}&region=${region}&practice_sk=${practice}&opportunity_status=${status}`,
        Method: HttpMethod.Get,
      },
      OpportunityDelete: {
        EndPoint: (opportunityId: any) =>
          `/opportunity/delete?id=${opportunityId}`,
        Method: HttpMethod.Delete,
      },
      Advisor: {
        EndPoint: `/users/role?role_id=advisor`,
        Method: HttpMethod.Get,
      },
      AdvisorsByGroup: {
        EndPoint: (groupSk: any) => `/groups/opp_advisors?group_sk=${groupSk}`,
        Method: HttpMethod.Get,
      },
      GroupsByAdvisor: {
        EndPoint: (advisorId: any) =>
          `/groups/assigned?is_assigned=true&advisor_id=${advisorId}`,
        Method: HttpMethod.Get,
      },
      OpportunityStatus: {
        EndPoint: `/opportunity/statuses`,
        Method: HttpMethod.Get,
      },
      OpportunityMoreColumns: {
        EndPoint: (opportunityId: any) =>
          `/opportunity/more_columns?opportunity_id=${opportunityId}`,
        Method: HttpMethod.Get,
      },
      OpportunityLogs: {
        EndPoint: (opportunityId: any) =>
          `/opportunitylogs?opportunity_id=${opportunityId}`,
        Method: HttpMethod.Get,
      },
      OpportunityEditGoals: {
        EndPoint: (practiceSk: any, metricId: any, year: any) =>
          `/groups/goals/bypractice?practice_sk=${practiceSk}&metric_id=${metricId}&year=${year}`,
        Method: HttpMethod.Get,
      },
      OpportunityAvailableYear: {
        EndPoint: (groupSk: any) =>
          `/groups/goals/available_years?group_sk=${groupSk}`,
        Method: HttpMethod.Get,
      },
      OpportunityUpdateStatus: {
        EndPoint: `/opportunity/status`,
        Method: HttpMethod.Patch,
      },
      OpportunityViewHistorical: {
        EndPoint: (id: any) => `/groups/store/column_history?id=${id}`,
        Method: HttpMethod.Get,
      },
      AdvisorGroups: {
        EndPoint: (id: any) => `/groups/advisor?advisor_id=${id}`,
        Method: HttpMethod.Get,
      },
    },
    MetricValueType: {
      EndPoint: "/blueprint/column",
      Method: HttpMethod.Patch,
    },
    GoalType: {
      EndPoint: "/blueprint/goal_type",
      Method: HttpMethod.Patch,
    },
    MetricBenchmark: {
      EndPoint: "/blueprint/metric_benchmark",
      Method: HttpMethod.Patch,
    },
    AssignMetrics: {
      EndPoint: "groups/template/assign",
      Method: HttpMethod.Post,
    },
    OpportunityData: {
      EndPoint: "/groups/store/bybucket?group_sk=1&metric_bucket_id=1",
      Method: HttpMethod.Get,
    },
    OpportunitySetData: {
      EndPoint: "/opportunity/create",
      Method: HttpMethod.Post,
    },
    Opportunity: {
      AllOpportunityMetrics: {
        EndPoint: (groupSk: any) =>
          `/groups/store/allmetrics?group_sk=${groupSk}`,
        Method: HttpMethod.Get,
      },
      MetricOpportunityData: {
        EndPoint: (groupSk: any) =>
          `/groups/store?group_sk=${groupSk}&metric_bucket_id=`,
        Method: HttpMethod.Get,
      },
      MetricOpportunityByBucket: {
        EndPoint: (groupSk: any, metricBucketId: any) =>
          `/groups/store/bybucket?group_sk=${groupSk}&metric_bucket_id=${metricBucketId}`,
        Method: HttpMethod.Get,
      },
      MetricGroupData: {
        EndPoint: (groupSk: any, metricBucketId: any) =>
          `/groups/store/bybucketgroupdata?group_sk=${groupSk}&metric_bucket_id=${metricBucketId}`,
        Method: HttpMethod.Get,
      },
      MetricRegionData: {
        EndPoint: (groupSk: any, metricId: any, region: any) =>
          `/groups/store/bybucketregiondata?group_sk=${groupSk}&metric_id=${metricId}&region=${region}`,
        Method: HttpMethod.Get,
      },
      MetricPracticeData: {
        EndPoint: (groupSk: any, metricId: any, region: any) =>
          `/groups/store/bybucketpracticedata?group_sk=${groupSk}&metric_id=${metricId}&region=${region}`,
        Method: HttpMethod.Get,
      },
      MetricOpportunityByMetric: {
        EndPoint: (groupSk: any, metricId: any) =>
          `/groups/store/bymetric?group_sk=${groupSk}&metric_id=${metricId}`,
        Method: HttpMethod.Get,
      },
      MetricStoreByMetric: {
        EndPoint: (groupSk: any, metricId: any) =>
          `/groups/store/bymetric?group_sk=${groupSk}&metric_id=${metricId}`,
        Method: HttpMethod.Get,
      },
      MetricStoreById: {
        EndPoint: (metricStoreId: any) =>
          `/groups/store/get_metric_store_by_id?metric_store_id=${metricStoreId}`,
        Method: HttpMethod.Get,
      },
      Opportunity: {
        EndPoint: (opportunityId: any) => `/opportunity?id=${opportunityId}`,
        Method: HttpMethod.Get,
      },
    },
  },
  Test: {
    LocalJSON: {
      EndPoint: "testData.json",
      Method: HttpMethod.Get,
    },
    LocalGoalsJSON: {
      EndPoint: "MetricGoalsData.json",
      Method: HttpMethod.Get,
    },
  },
  resourceBudget: {
    // clinical
    Providers: {
      EndPoint: (practice_sk: number, provider_type: string) =>
        `/resource/clinical/activeproviders?practice_sk=${practice_sk}&provider_type=${provider_type}`,
      Method: HttpMethod.Get,
    },
    clinicalCreate: {
      EndPoint: "/resource/clinical",
      Method: HttpMethod.Post,
    },
    clinicalForecastCreate: {
      EndPoint: "/resource/clinical?is_forecast=true",
      Method: HttpMethod.Post,
    },
    clinical: {
      EndPoint: (params: any) => {
        const { year, practiceSk, isForecast, month, providerType } = params
        if (isForecast) {
          return `/resource/clinical?year=${year}&practice_sk=${practiceSk}&month=${month}&provider_type=${providerType}&is_forecast=${isForecast}`
        }
        return `/resource/clinical?year=${year}&practice_sk=${practiceSk}&month=${month}&provider_type=${providerType}`
      },
      Method: HttpMethod.Get,
    },
    clinicalUpdate: {
      EndPoint: (params: any) => {
        const { year, practiceSk, published } = params
        if (published) {
          return `/resource/clinical?year=${year}&practice_sk=${practiceSk}&is_forecast=false`
        }

        return `/resource/clinical?year=${year}&practice_sk=${practiceSk}&is_forecast=true`
      },
      Method: HttpMethod.Patch,
    },
    clinicalDelete: {
      EndPoint: (params: any) => {
        const { year, practiceSk, id, published } = params
        if (published) {
          return `/resource/clinical?id=${id}&year=${year}&practice_sk=${practiceSk}&is_forecast=false`
        }
        return `/resource/clinical?id=${id}&year=${year}&practice_sk=${practiceSk}&is_forecast=true`
      },
      Method: HttpMethod.Delete,
    },

    // Non-clinical
    nonClinical: {
      EndPoint: (params: any) => {
        const { year, practiceSk, month, isForecast } = params
        if (isForecast) {
          return `/resource/non_clinical?year=${year}&practice_sk=${practiceSk}&month=${month}&is_forecast=${isForecast}`
        }
        return `/resource/non_clinical?year=${year}&practice_sk=${practiceSk}&month=${month}`
      },
      Method: HttpMethod.Get,
    },
    nonClinicalUpdate: {
      EndPoint: (params: any) => {
        const { year, practiceSk, published } = params
        if (published) {
          return `/resource/non_clinical?year=${year}&practice_sk=${practiceSk}&is_forecast=false`
        }
        return `/resource/non_clinical?year=${year}&practice_sk=${practiceSk}&is_forecast=true`
      },
      Method: HttpMethod.Patch,
    },
    nonClinicalRoles: {
      EndPoint: "/resource/non_clinical/roles",
      Method: HttpMethod.Get,
    },
    nonClinicalDelete: {
      EndPoint: (params: any) => {
        const { year, practiceSk, id, published } = params
        if (published) {
          return `/resource/non_clinical?id=${id}&year=${year}&practice_sk=${practiceSk}&is_forecast=false`
        }
        return `/resource/non_clinical?id=${id}&year=${year}&practice_sk=${practiceSk}&is_forecast=true`
      },
      Method: HttpMethod.Delete,
    },
    nonClinicalCreate: {
      EndPoint: "/resource/non_clinical",
      Method: HttpMethod.Post,
    },
    nonClinicalForecastCreate: {
      EndPoint: "/resource/non_clinical?is_forecast=true",
      Method: HttpMethod.Post,
    },
    // Common endpoints
    clinicalCopyOptions: {
      EndPoint: (params: any) => {
        const { year, practiceSk } = params
        return `/resource/clinical/monthwise_flag?year=${year}&practice_sk=${practiceSk}`
      },
      Method: HttpMethod.Get,
    },
    nonClinicalCopyOptions: {
      EndPoint: (params: any) => {
        const { year, practiceSk } = params
        return `/resource/non_clinical/monthwise_flag?year=${year}&practice_sk=${practiceSk}`
      },
      Method: HttpMethod.Get,
    },
    publishBudget: {
      EndPoint: (args: any) => {
        const { practiceSk, year } = args
        return `/resource/practice/publish_budget?year=${year}&practice_sk=${practiceSk}`
      },
      Method: HttpMethod.Post,
    },
    setCopyToOptions: {
      EndPoint: (params: any) => {
        const { year, practiceSk, month, isClinical, providerType } = params
        return `/resource/clinical/copy_budget?year=${year}&month=${month}&is_clinical=${isClinical}&practice_sk=${practiceSk}&provider_type=${providerType}`
      },
      Method: HttpMethod.Post,
    },
    availabelBudgetYears: {
      EndPoint: (practiceSk: number) => {
        return `/resource/available_years?practice_sk=${practiceSk}`
      },
      Method: HttpMethod.Get,
    },
    syncBudget: {
      EndPoint: (practiceSk: number, year: number) => {
        return `/resource/common/all/sync_to_pnl_budget?year=${year}&practice_sk=${practiceSk}`
      },
      Method: HttpMethod.Get,
    },
    copyToForecast: {
      EndPoint: (params: any) => {
        const { year, practice_sk } = params
        return `/resource/copy_forecast?year=${year}&practice_sk=${practice_sk}`
      },
      Method: HttpMethod.Post,
    },
  },
  pnlBudget: {
    pnlBudgetData: {
      EndPoint: (params: any) => {
        const { groupSk, classId, year } = params
        return `/pnl_budget/pnl_budget?group_sk=${groupSk}&class_id=${classId}&budget_year=${year}`
      },
      Method: HttpMethod.Get,
    },
    saveBudgetData: {
      EndPoint: "/pnl_budget/createorupdate",
      Method: HttpMethod.Post,
    },
    budgetYears: {
      EndPoint: "/pnl_budget/budget/available_years",
      Method: HttpMethod.Get,
    },
    reportingYears: {
      EndPoint: (groupSk: number) =>
        `/pnl_budget/report/available_years?group_sk=${groupSk}`,
      Method: HttpMethod.Get,
    },
    pnlReportingClasses: {
      EndPoint: "/pnl_budget/classes",
      Method: HttpMethod.Post,
    },
    pnlBudgetClasses: {
      EndPoint: (group_sk: any) =>
        `/pnl_budget/budget_classes?group_sk=${group_sk}`,
      Method: HttpMethod.Get,
    },
    pnlReportingTable: {
      EndPoint: "/pnl_budget/budget-vs-actual",
      Method: HttpMethod.Post,
    },
    pnlReportingByLineItem: {
      EndPoint: "/pnl_budget/report_by_lineitem",
      Method: HttpMethod.Post,
    },
    pnlTransactionData: {
      EndPoint: "/pnl_budget/report_by_acc_subclass",
      Method: HttpMethod.Post,
    },
  },
  DoctorCompensation: {
    GetContracts: {
      EndPoint: (
        group_sk: any,
        region: any,
        practice_sk: any,
        doctor_name: any,
        status: any,
      ) =>
        `/doctor_compensation/get_contracts?status=${status}&doctor_name=${doctor_name}&practice_sk=${practice_sk}&group_sk=${group_sk}&region=${region}`,
      Method: HttpMethod.Get,
    },
    NewContract: {
      EndPoint: `/doctor_compensation/create_contract`,
      Method: HttpMethod.Post,
    },
    ActiveProviders: {
      EndPoint: (group_sk: any, region: any, practice_sk: any) =>
        `/doctor_compensation/activeproviders?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    ContractDoctors: {
      EndPoint: (group_sk: any, region: any, practice_sk: any) =>
        `/doctor_compensation/contract_doctors?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    EditContract: {
      EndPoint: (comp_plan_id: any) =>
        `/doctor_compensation/update_contract?comp_plan_id=${comp_plan_id}`,
      Method: HttpMethod.Patch,
    },
    RemoveContract: {
      EndPoint: (comp_plan_id: any) =>
        `/doctor_compensation/delete_contract?comp_plan_id=${comp_plan_id}`,
      Method: HttpMethod.Delete,
    },
    AvailableYears: {
      EndPoint: (practice_sk: any) =>
        `/doctor_compensation/available_years?practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    QboMemo: {
      EndPoint: (practice_sk: any) =>
        `/doctor_compensation/qbo_memo?practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    SummaryMemo: {
      EndPoint: (practice_sk: any) =>
        `/doctor_compensation/summary/active_providers?practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    DocSummary: {
      EndPoint: (
        group_sk: any,
        region: any,
        practice_sk: any,
        year: any,
        memo: any,
      ) =>
        // `/doctor_compensation/get_doctor_summary?practice_sk=${practice_sk}&year=${year}&month=${month}&memo=${memo}&group_sk=${group_sk}&region=${region}`,
        `/doctor_compensation/summary`,
      Method: HttpMethod.Post,
    },
    Payroll: {
      EndPoint: `/doctor_compensation/payroll`,
      Method: HttpMethod.Post,
    },
    LabExpenses: {
      EndPoint: `/doctor_compensation/lab_expenses`,
      Method: HttpMethod.Post,
    },
    JournalEntries: {
      EndPoint: (
        group_sk: any,
        region: any,
        practice_sk: any,
        year: any,
        month: any,
        memo: any,
      ) =>
        `/doctor_compensation/journal_entries?group_sk=${group_sk}&year=${year}&month=${month}&practice_sk=${practice_sk}&memo=${memo}&region=${region}`,
      Method: HttpMethod.Get,
    },
  },
  ProntoAi: {
    GetProntoAiTable: {
      EndPoint: (group_sk: any, region: any, practice_sk: any) =>
        `/pronto_ai?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}`,
      Method: HttpMethod.Get,
    },
    GetProntoAi: {
      EndPoint: (
        group_sk: any,
        region: any,
        practice_sk: any,
        metric_id: any,
      ) =>
        `/pronto_ai/getProntoAiHoverTile/?group_sk=${group_sk}&region=${region}&practice_sk=${practice_sk}&metric_id=${metric_id}`,
      Method: HttpMethod.Get,
    },
  },
  User: {
    AllRolesAndPerms: {
      EndPoint: `/permissions`,
      Method: HttpMethod.Get,
    },
    UserContactNumber: {
      EndPoint: (uid: any) => `/users?uid=${uid}`,
      Method: HttpMethod.Patch,
    },
    UserByUserId: {
      EndPoint: (uid: any) => `/users/profile?uid=${uid}`,
      Method: HttpMethod.Get,
    },
    UpdateGroup: {
      EndPoint: "mapping/update",
      Method: HttpMethod.Patch,
    },
    GetPossibleRoles: {
      EndPoint: (uid: any) => `roles/possible_role_categories?uid=${uid}`,
      Method: HttpMethod.Get,
    },
    GetRoles: {
      EndPoint: (role: string) => `roles?role_category=${role}`,
      Method: HttpMethod.Get,
    },
    UpdateRoles: {
      EndPoint: "users/role/change",
      Method: HttpMethod.Patch,
    },
    DeleteUser: {
      EndPoint: (uid: any) => `/users/delete/?uid=${uid}`,
      Method: HttpMethod.Delete,
    },
    RemoveGroupDetails: {
      EndPoint: (uid: any) => `mapping/delete?uid=${uid}`,
      Method: HttpMethod.Delete,
    },
  },
  Users: {
    AllUsers: {
      EndPoint: `/users/all`,
      Method: HttpMethod.Get,
    },
    NewUser: {
      EndPoint: `/auth/create`,
      Method: HttpMethod.Post,
    },
    NewUserStatus: {
      EndPoint: (uid: any) => `/users?uid=${uid}`,
      Method: HttpMethod.Patch,
    },
    UserStatus: {
      EndPoint: (uid: any) => `/users?uid=${uid}`,
      Method: HttpMethod.Patch,
    },
    ResendInvitation: {
      EndPoint: (uid: any) => `/users/resend_invitation?uid=${uid}`,
      Method: HttpMethod.Get,
    },
  },
  groupProfile: {
    GroupStatus: {
      EndPoint: (id: any) => `/groups/assign_group_status?group_sk=${id}`,
      Method: HttpMethod.Patch,
    },
    MetricDetails: {
      EndPoint: (id: any) => `/groups/template?group_sk=${id}`,
      Method: HttpMethod.Get,
    },
    groupInfo: {
      EndPoint: (id: any) => `/groups/group_profile?group_sk=${id}`,
      Method: HttpMethod.Get,
    },
    AllPractices: {
      EndPoint: (id: any) => `/practice/all_practices?group_sk=${id}`,
      Method: HttpMethod.Get,
    },
    UpdatePracticeStatus: {
      EndPoint: (id: any) =>
        `/practice/update_practice_status?practice_sk=${id}`,
      Method: HttpMethod.Patch,
    },
    metricAssign: {
      EndPoint: `/groups/template/assign`,
      Method: HttpMethod.Post,
    },
    metricAssignRemove: {
      EndPoint: `/groups/template/remove`,
      Method: HttpMethod.Delete,
    },
    GroupDetailsRegionsByGroups: {
      EndPoint: `/groups/hierarchy/regions`,
      Method: HttpMethod.Post,
    },
    GroupDetailsPracticesByRegions: {
      EndPoint: `/groups/hierarchy/practices`,
      Method: HttpMethod.Post,
    },
    AssignPc: {
      EndPoint: (groupSk: any, gaId: any) =>
        `/groups/assign_primary_contact?group_sk=${groupSk}&primary_contact_id=${gaId}`,
      Method: HttpMethod.Patch,
    },
    AssignAdvisor: {
      EndPoint: (groupSk: any, advisorId: any) =>
        `/groups/assign_advisor?group_sk=${groupSk}&advisor_id=${advisorId}`,
      Method: HttpMethod.Post,
    },
    AssignCsm: {
      EndPoint: (groupSk: any, csmId: any) =>
        `/groups/assign_csm?group_sk=${groupSk}&csm_id=${csmId}`,
      Method: HttpMethod.Post,
    },
  },
  customerManagement: {
    Assigned_UnAssignedGroups: {
      EndPoint: (flag: any) => `/groups/all?tab=${flag}`,
      Method: HttpMethod.Get,
    },
  },
  Roles: {
    AllUserRoles: {
      EndPoint: `/roles`,
      Method: HttpMethod.Get,
    },
    RoleCategories: {
      EndPoint: `/roles/role_categories`,
      Method: HttpMethod.Get,
    },
    NewRole: {
      EndPoint: `/roles/create`,
      Method: HttpMethod.Post,
    },
    EditRole: {
      EndPoint: (roleId: string) => `/roles/update?role_id=${roleId}`,
      Method: HttpMethod.Patch,
    },
    DelRole: {
      EndPoint: (roleId: string) => `/roles/delete?role_id=${roleId}`,
      Method: HttpMethod.Delete,
    },
  },
  Huddle: {
    Huddle_Yesterday_Today: {
      EndPoint: (id: any) => `/huddle/?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    HuddleEditHours: {
      EndPoint: "/huddle/yesterday/hours",
      Method: HttpMethod.Patch,
    },
    HuddleSummary: {
      EndPoint: (id: any) => `/huddle/huddle_summary?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    HuddleSummaryKeyMetrics: {
      EndPoint: (id: any) => `/key_metrics?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    HuddleActiveOpportunities: {
      EndPoint: (id: any) => `/opportunity/active?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    ProviderSummary: {
      EndPoint: (id: any) => `/huddle/provider_summary?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    HuddleTodayAudit: {
      EndPoint: (id: any) => `/audit/today?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    HuddleYesterdayAudit: {
      EndPoint: (id: any) => `/audit/yesterday?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
    HuddleTomorrowAudit: {
      EndPoint: (id: any) => `/audit/tomorrow?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
  },
  AuditAndCompliance: {
    AuditData: {
      EndPoint: (practiceSk: number) =>
        `/audit_compliance/audit?practice_sk=${practiceSk}`,
      Method: HttpMethod.Get,
    },
    ComplianceData: {
      EndPoint: (practiceSk: number) =>
        `/compliance_summary?practice_sk=${practiceSk}`,
      Method: HttpMethod.Get,
    },
  },
  ProviderSummery: {
    SummaryData: {
      EndPoint: (id: any) => `productionsummary/?practice_sk=${id}`,
      Method: HttpMethod.Get,
    },
  },
  HelpCenter: {
    CreateResource: {
      EndPoint: "/help_center/resource",
      Method: HttpMethod.Post,
    },
    FolderDelete: {
      EndPoint: (id: string) => `/help_center/resource?help_center_id=${id}`,
      Method: HttpMethod.Delete,
    },
    FileDelete: {
      EndPoint: (id: string) =>
        `/help_center/resource/deleteAttachment?key=${id}`,
      Method: HttpMethod.Delete,
    },

    UpdateFileById: {
      EndPoint: (id: any) => `/help_center/resource?help_center_id=${id}`,
      Method: HttpMethod.Patch,
    },
    AddAttachment: {
      EndPoint: (id: string) =>
        `/help_center/resource/addAttachments?help_center_id=${id}`,
      Method: HttpMethod.Post,
    },
    //
    FileUpload: {
      EndPoint: "/help_center/upload",
      Method: HttpMethod.Post,
    },

    FetchHelpCenter: {
      EndPoint: "/help_center/resources",
      Method: HttpMethod.Get,
    },
  },
}

export default ApiRoutes
